import { type ReactNode } from "react";

/**
 * Marco de los modales que bloquean la app: overlay con la interfaz atenuada y
 * desenfocada detrás, cabecera azul (título + subtítulo opcional) y cuerpo blanco.
 * Lo usan las pantallas de estado de `AccessGate` (acceso vencido, cuenta en
 * evaluación).
 */
export function GateCard({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-primary/5 p-6 backdrop-blur-sm">
      <div className="w-full max-w-lg overflow-hidden rounded-3xl border bg-card shadow-2xl shadow-slate-900/25">
        {/* Header */}
        <div className="bg-primary px-7 py-7 text-primary-foreground sm:px-9">
          <h1 className="text-2xl font-extrabold leading-tight tracking-tight sm:text-3xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 text-sm leading-relaxed text-primary-foreground/85">
              {subtitle}
            </p>
          )}
        </div>
        {/* Body */}
        <div className="px-7 py-7 sm:px-9">{children}</div>
      </div>
    </div>
  );
}
